import type { Socket } from "socket.io-client";
import { create } from "zustand";
import type { SocketStore } from "../socket/types";

const useSocketAIStore = create<SocketStore>((set) => ({
  socket: null,
  listMessage: [],
  listRoom: [],
  focusRoom: null,
  setSocket: (newSocket: Socket) => {
    set({ socket: newSocket });
  },
  disconnectSocket: () => {
    set((state) => {
      if (state.socket) {
        state.socket.disconnect();
      }
      return { socket: null, listMessage: [], listRoom: [] };
    });
  },
  addMessage: (message: any) => {
    set((state) => ({
      listMessage: [...state.listMessage, message],
    }));
  },
  setMessages: (listMessage: any[]) => {
    set({ listMessage: listMessage || [] });
  },
  setRooms: (listRoom: any[]) => {
    set({ listRoom });
  },
  setFocusRoom: (focusRoom: { id: string; toUser: string; users: any[] | null } | null) => {
    set({ focusRoom });
  },
}));

export default useSocketAIStore;
